import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoggedIn, removeScript } from '../Utils/Utils';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';

import { Helmet } from 'react-helmet';
import LoadingSpinner from '../Layout/LoadingSpinner';
import CourseLandingNew from '../components/LandingNew/CourseLanding';
import PengalamanBelajar from '../components/LandingNew/PengalamanBelajar';
import SertifikatLanding from '../components/LandingNew/SertifikatLanding';
import Tentang from '../components/LandingNew/Tentang';
import { Faq, HeroBanner, SubscriptionOptions } from './_components';

const LandingPageNew = ({ refer }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);

  useEffect(() => {
    const init = async () => {
      if (refer) {
        dispatch({ type: 'UPDATE_LOGINPOPUP_OPEN', payload: 1 });
        dispatch({ type: 'UPDATE_REGISTERPOPUP_OPEN', payload: 1 });
      }

      dispatch({ type: 'TOGGLE_LOADING_TRUE' });

      const user_check_api = await isLoggedIn();
      if (user_check_api.profile_data !== null) {
        if (!user_check_api.profile_data?.is_onboarding_done) {
          window.location.href = '/complete-on-boarding';
        }
      }

      dispatch({ type: 'TOGGLE_LOADING_FALSE' });

      window.gtag('event', 'conversion', {
        send_to: 'AW-651417204/1HVKCPu3rIACEPSsz7YC',
      });
    };

    init();

    return () => {
      removeScript('https://app.sandbox.midtrans.com/snap/snap.js');
    };
  }, [dispatch, refer]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MyEduSolveX | Kelas Online Literasi Digital Terbaik</title>
        <meta name="title" content="MyEduSolveX | Kelas Online Literasi Digital Terbaik" />
        <meta
          name="description"
          content="Yuk, tingkatkan daya saingmu dengan mengikuti kelas online bareng MyEduSolveX. Akses dimana saja, kapan saja!"
        />
        <meta property="og:title" content="MyEduSolveX | Kelas Online Literasi Digital Terbaik" />
        <meta
          property="twitter:title"
          content="MyEduSolveX | Kelas Online Literasi Digital Terbaik"
        />
        <meta
          property="og:description"
          content="Yuk, tingkatkan daya saingmu dengan mengikuti kelas online bareng MyEduSolveX. Akses dimana saja, kapan saja!"
        />
        <meta
          property="twitter:description"
          content="Yuk, tingkatkan daya saingmu dengan mengikuti kelas online bareng MyEduSolveX. Akses dimana saja, kapan saja!"
        />
        <meta
          name="google-site-verification"
          content="L9n7ma8RGq0-0kUevozDWC8mg2D7kwK9SsnvndWdQEw"
        />
        <script src="https://www.googleoptimize.com/optimize.js?id=OPT-5S5MCK4"></script>
      </Helmet>

      <Header />

      <HeroBanner />

      <SertifikatLanding />

      <CourseLandingNew />

      <Tentang />

      <PengalamanBelajar />

      <SubscriptionOptions />

      <Faq />

      <Footer />

      {isLoading && <LoadingSpinner text="Mohon menunggu.." />}
    </>
  );
};

export default LandingPageNew;
